// extracted by mini-css-extract-plugin
export default {"table_header":"vendor-vip-list_table_header__oCLMJ","table_td":"vendor-vip-list_table_td__dBUTq"};